import { Button, Icon, Text, HStack } from '@chakra-ui/react';
import { LuChevronDown, LuX } from 'react-icons/lu';

const FilterSelectTrigger = ({
  isOpen,
  displayText,
  selectedCount,
  onToggle,
  onClearAll,
  isDisabled,
  triggerRef,
}: {
  isOpen: boolean;
  displayText: string;
  selectedCount: number;
  onToggle: () => void;
  onClearAll: (e: React.MouseEvent) => void;
  isDisabled: boolean;
  triggerRef: React.RefObject<HTMLButtonElement | null>;
}) => (
  <Button
    ref={triggerRef}
    variant="outline"
    size="md"
    width="100%"
    justifyContent="space-between"
    alignItems="center"
    border="1px solid"
    borderColor="gray.200"
    backgroundColor="white"
    color="gray.700"
    px={3}
    py={2.5}
    _hover={{
      borderColor: 'gray.300',
      backgroundColor: 'gray.50',
    }}
    _active={{
      borderColor: 'purple.500',
      backgroundColor: 'white',
    }}
    disabled={isDisabled}
    onClick={onToggle}
  >
    <Text
      fontSize="14px"
      color={selectedCount > 0 ? 'gray.900' : 'gray.500'}
      textAlign="left"
      flex={1}
      overflow="hidden"
      textOverflow="ellipsis"
      whiteSpace="nowrap"
    >
      {displayText}
    </Text>

    <HStack gap={1} alignItems="center">
      {selectedCount > 0 && (
        <HStack gap={1} alignItems="center">
          <Text fontSize="16px" color="purple.500" fontWeight={500}>
            {`(${selectedCount})`}
          </Text>
          <Icon
            as={LuX}
            onClick={onClearAll}
            color="gray.fg"
            _hover={{ backgroundColor: 'gray.100' }}
            aria-label="Clear selection"
            cursor="pointer"
          />
        </HStack>
      )}
      <Icon as={LuChevronDown} color="gray.500" transform={isOpen ? 'rotate(180deg)' : 'rotate(0deg)'} transition="transform 0.2s" />
    </HStack>
  </Button>
);

export default FilterSelectTrigger;
